import MenuItem from "./MenuItem";

export const TAB_INDEX_FOCUS_WITH_JS_ONLY = -1;
export type TooltipPosition = (typeof MenuItem.tooltipPositions)[keyof typeof MenuItem.tooltipPositions];
